<template>
  <div style="position:relative;">
    <div id="avg" style="display:inline-block; float:left; width:45%; margin-left:10px; margin-right:5px;">
      <!-- <div style="position:absolute; left:0;">asdf</div> -->
    </div>

    <div id="qmax" style="display:inline-block; width:45%; position:relative;">
      <!-- <div style="position:absolute; left:0;">QMAX</div> -->
    </div>
  </div>
</template>

<script>

import _ from 'lodash'
import d3 from 'd3'
import sirokyAvgSrc from '../assets/wpd_projectA1.json'
import sirokyQmaxSrc from '../assets/wpd_projectM1.json'

export default {
  name: 'Ahmet',
  data () {
    return {
      config: {}
    }
  },
  methods: {
    dots (dt) {
      var avgSvg = d3.select('#avgSvg')

      avgSvg.selectAll('circle')
        .data([0])
        .enter().append('circle')
        .style('stroke', 'no')
        .style('fill', 'red')
        .attr('r', 3)
        .attr('cx', ((this.config.avgSvg.width / this.config.avgSvg.aXmax) * parseInt(dt.total_volume, 10)))
        .attr('cy', this.config.avgSvg.height - ((this.config.avgSvg.height / this.config.avgSvg.aYmax) * parseInt(dt.average_speed, 10)))

      var qmaxSvg = d3.select('#qmaxSvg')

      qmaxSvg.selectAll('circle')
        .data([0])
        .enter().append('circle')
        .style('stroke', 'no')
        .style('fill', 'red')
        .attr('r', 3)
        .attr('cx', ((this.config.qmaxSvg.width2 / this.config.qmaxSvg.qXmax) * parseInt(dt.total_volume, 10)))
        .attr('cy', this.config.qmaxSvg.height2 - ((this.config.qmaxSvg.height2 / this.config.qmaxSvg.qYmax) * parseInt(dt.max_speed, 10)))
    }
  },
  mounted () {
    var vm = this

    console.log('nomogramDev mounted')
    // console.log(sirokyAvgSrc.datasetColl[0].data)

    /* console.log('this.nomogram')
    console.log(this.nomogram) */

    var sirokyAvg = {}
    var sirokyQmax = {}

    console.log()

    // sirokyAvg['1'] = _.map(sirokyAvgSrc.datasetColl[0].data, function (d) { return {x: d.value[0], y: d.value[1]} })
    sirokyAvg['1'] = _.map(_.sortBy(sirokyAvgSrc.datasetColl[0].data, [function (d) { return d.value[0] }]), function (d) { return {x: d.value[0], y: d.value[1]} })
    sirokyAvg['0.5'] = _.map(_.sortBy(sirokyAvgSrc.datasetColl[1].data, [function (d) { return d.value[0] }]), function (d) { return {x: d.value[0], y: d.value[1]} })
    sirokyAvg['0'] = _.map(_.sortBy(sirokyAvgSrc.datasetColl[2].data, [function (d) { return d.value[0] }]), function (d) { return {x: d.value[0], y: d.value[1]} })
    sirokyAvg['-0.5'] = _.map(_.sortBy(sirokyAvgSrc.datasetColl[3].data, [function (d) { return d.value[0] }]), function (d) { return {x: d.value[0], y: d.value[1]} })
    sirokyAvg['-1'] = _.map(_.sortBy(sirokyAvgSrc.datasetColl[4].data, [function (d) { return d.value[0] }]), function (d) { return {x: d.value[0], y: d.value[1]} })
    sirokyAvg['-1.5'] = _.map(_.sortBy(sirokyAvgSrc.datasetColl[5].data, [function (d) { return d.value[0] }]), function (d) { return {x: d.value[0], y: d.value[1]} })
    sirokyAvg['-2'] = _.map(_.sortBy(sirokyAvgSrc.datasetColl[6].data, [function (d) { return d.value[0] }]), function (d) { return {x: d.value[0], y: d.value[1]} })
    sirokyAvg['-2.5'] = _.map(_.sortBy(sirokyAvgSrc.datasetColl[7].data, [function (d) { return d.value[0] }]), function (d) { return {x: d.value[0], y: d.value[1]} })
    sirokyAvg['-3'] = _.map(_.sortBy(sirokyAvgSrc.datasetColl[8].data, [function (d) { return d.value[0] }]), function (d) { return {x: d.value[0], y: d.value[1]} })

    sirokyQmax['0'] = _.map(_.sortBy(sirokyQmaxSrc.datasetColl[0].data, [function (d) { return d.value[0] }]), function (d) { return {x: d.value[0], y: d.value[1]} })
    sirokyQmax['-0.5'] = _.map(_.sortBy(sirokyQmaxSrc.datasetColl[1].data, [function (d) { return d.value[0] }]), function (d) { return {x: d.value[0], y: d.value[1]} })
    sirokyQmax['-1'] = _.map(_.sortBy(sirokyQmaxSrc.datasetColl[2].data, [function (d) { return d.value[0] }]), function (d) { return {x: d.value[0], y: d.value[1]} })
    sirokyQmax['-1.5'] = _.map(_.sortBy(sirokyQmaxSrc.datasetColl[3].data, [function (d) { return d.value[0] }]), function (d) { return {x: d.value[0], y: d.value[1]} })
    sirokyQmax['-2'] = _.map(_.sortBy(sirokyQmaxSrc.datasetColl[4].data, [function (d) { return d.value[0] }]), function (d) { return {x: d.value[0], y: d.value[1]} })
    sirokyQmax['-2.5'] = _.map(_.sortBy(sirokyQmaxSrc.datasetColl[5].data, [function (d) { return d.value[0] }]), function (d) { return {x: d.value[0], y: d.value[1]} })
    sirokyQmax['-3'] = _.map(_.sortBy(sirokyQmaxSrc.datasetColl[6].data, [function (d) { return d.value[0] }]), function (d) { return {x: d.value[0], y: d.value[1]} })

    var margin = {top: 30, right: 20, bottom: 30, left: 40}
    // var width = 674 - margin.left - margin.right
    // var height = 781 - margin.top - margin.bottom
    var width = 604 * 0.44
    var height = 721 * 0.185

    var width2 = 595 * 0.44
    var height2 = 716 * 0.185

    var x = d3.scale.linear().range([0, width])
    var y = d3.scale.linear().range([height, 0])

    var x2 = d3.scale.linear().range([0, width2])
    var y2 = d3.scale.linear().range([height2, 0])

    var xAxis = d3.svg.axis().scale(x).orient('bottom').ticks(5)
    var yAxis = d3.svg.axis().scale(y).orient('left').ticks(5)

    var xAxis2 = d3.svg.axis().scale(x2).orient('bottom').ticks(5)
    var yAxis2 = d3.svg.axis().scale(y2).orient('left').ticks(5)

    // var interpolateTypes = ['linear','step-before','step-after','basis','basis-open','basis-closed','bundle','cardinal','cardinal-open','cardinal-closed','monotone'];

    var valueline = d3.svg.line().interpolate('basis').x(function (d) { return x(d.x) }).y(function (d) { return y(d.y) })
    var valueline2 = d3.svg.line().interpolate('basis').x(function (d) { return x2(d.x) }).y(function (d) { return y2(d.y) })

    var avgSvg = d3.select('#avg').append('svg').attr('class', 'nomogramDev').attr('width', width + margin.left + margin.right).attr('height', height + margin.top + margin.bottom).append('g').attr('id', 'avgSvg').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')
    var qmaxSvg = d3.select('#qmax').append('svg').attr('class', 'nomogramDev').attr('width', width2 + margin.left + margin.right).attr('height', height2 + margin.top + margin.bottom).append('g').attr('id', 'qmaxSvg').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')

    /* data.forEach(function (d) {
        d.date = parseDate(d.date)
        d.close = +d.close
      }) */

    var aXmax = 500
    var aYmax = 30

    x.domain([0, aXmax])
    y.domain([0, aYmax])

    this.config.avgSvg = {
      width: width,
      height: height,
      aXmax: aXmax,
      aYmax: aYmax
    }

    avgSvg.append('text')
      .attr('transform', 'translate(10, 0)')
      .attr('dy', '.25em')
      .attr('text-anchor', 'start')
      .style('fill', 'steelblue')
      .text(vm.$t('report.avg_flow_rate'))

    avgSvg.append('path').attr('class', 'line').attr('d', valueline(sirokyAvg['1']))
    avgSvg.append('text')
      .attr('transform', 'translate(' + width + ', ' + y(sirokyAvg['1'][10].y) + ')')
      .attr('dy', '.25em')
      .attr('text-anchor', 'start')
      .style('fill', 'steelblue')
      .text('+1')

    avgSvg.append('path').attr('class', 'dashline').attr('d', valueline(sirokyAvg['0.5']))

    avgSvg.append('path').attr('class', 'line').attr('d', valueline(sirokyAvg['0']))
    avgSvg.append('text')
      .attr('transform', 'translate(' + width + ', ' + y(sirokyAvg['0'][10].y) + ')')
      .attr('dy', '.25em')
      .attr('text-anchor', 'start')
      .style('fill', 'steelblue')
      .text('0')

    avgSvg.append('path').attr('class', 'dashline').attr('d', valueline(sirokyAvg['-0.5']))

    avgSvg.append('path').attr('class', 'line').attr('d', valueline(sirokyAvg['-1']))
    avgSvg.append('text')
      .attr('transform', 'translate(' + width + ', ' + y(sirokyAvg['-1'][10].y) + ')')
      .attr('dy', '.25em')
      .attr('text-anchor', 'start')
      .style('fill', 'steelblue')
      .text('-1')

    avgSvg.append('path').attr('class', 'dashline').attr('d', valueline(sirokyAvg['-1.5']))

    avgSvg.append('path').attr('class', 'line').attr('d', valueline(sirokyAvg['-2']))
    avgSvg.append('text')
      .attr('transform', 'translate(' + width + ', ' + y(sirokyAvg['-2'][10].y) + ')')
      .attr('dy', '.25em')
      .attr('text-anchor', 'start')
      .style('fill', 'steelblue')
      .text('-2')

    avgSvg.append('path').attr('class', 'dashline').attr('d', valueline(sirokyAvg['-2.5']))

    avgSvg.append('path').attr('class', 'line').attr('d', valueline(sirokyAvg['-3']))
    avgSvg.append('text')
      .attr('transform', 'translate(' + width + ', ' + y(sirokyAvg['-3'][9].y) + ')')
      .attr('dy', '.25em')
      .attr('text-anchor', 'start')
      .style('fill', 'steelblue')
      .text('-3')

    avgSvg.append('g').attr('class', 'x axis').attr('transform', 'translate(0,' + height + ')').call(xAxis)
    avgSvg.append('g').attr('class', 'y axis').call(yAxis)

    var area = d3.svg.area()
      .x(function (d) { console.log(d.x); return x(d.x) })
      .y0(height)
      .y1(function (d) { return y(d.y) })

    avgSvg.append('path')
      .data([sirokyAvg['-2']])
      .attr('class', 'area')
      .attr('d', area)

    /* - - - - - - - - - - */

    var qXmax = 500
    var qYmax = 30

    x2.domain([0, qXmax])
    y2.domain([0, qYmax])

    this.config.qmaxSvg = {
      width2: width2,
      height2: height2,
      qXmax: qXmax,
      qYmax: qYmax
    }

    qmaxSvg.append('text')
      .attr('transform', 'translate(10, 0)')
      .attr('dy', '.25em')
      .attr('text-anchor', 'start')
      .style('fill', 'steelblue')
      .text(vm.$t('report.max_flow_rate'))

    qmaxSvg.append('path').attr('class', 'line').attr('d', valueline2(sirokyQmax['0']))
    qmaxSvg.append('text')
      .attr('transform', 'translate(' + width2 + ', ' + y(sirokyQmax['0'][10].y) + ')')
      .attr('dy', '.25em')
      .attr('text-anchor', 'start')
      .style('fill', 'steelblue')
      .text('0')

    qmaxSvg.append('path').attr('class', 'dashline').attr('d', valueline2(sirokyQmax['-0.5']))

    qmaxSvg.append('path').attr('class', 'line').attr('d', valueline2(sirokyQmax['-1']))
    qmaxSvg.append('text')
      .attr('transform', 'translate(' + width2 + ', ' + y(sirokyQmax['-1'][10].y) + ')')
      .attr('dy', '.25em')
      .attr('text-anchor', 'start')
      .style('fill', 'steelblue')
      .text('-1')

    qmaxSvg.append('path').attr('class', 'dashline').attr('d', valueline2(sirokyQmax['-1.5']))

    qmaxSvg.append('path').attr('class', 'line').attr('d', valueline2(sirokyQmax['-2']))
    qmaxSvg.append('text')
      .attr('transform', 'translate(' + width2 + ', ' + y(sirokyQmax['-2'][10].y) + ')')
      .attr('dy', '.25em')
      .attr('text-anchor', 'start')
      .style('fill', 'steelblue')
      .text('-2')

    qmaxSvg.append('path').attr('class', 'dashline').attr('d', valueline2(sirokyQmax['-2.5']))

    qmaxSvg.append('path').attr('class', 'line').attr('d', valueline2(sirokyQmax['-3']))
    qmaxSvg.append('text')
      .attr('transform', 'translate(' + width2 + ', ' + y(sirokyQmax['-3'][10].y) + ')')
      .attr('dy', '.25em')
      .attr('text-anchor', 'start')
      .style('fill', 'steelblue')
      .text('-3')

    qmaxSvg.append('g').attr('class', 'x axis').attr('transform', 'translate(0,' + height2 + ')').call(xAxis2)
    qmaxSvg.append('g').attr('class', 'y axis').call(yAxis2)

    var area2 = d3.svg.area()
      .x(function (d) { return x(d.x) })
      .y0(height)
      .y1(function (d) { return y(d.y) })

    qmaxSvg.append('path')
      .data([sirokyQmax['-2']])
      .attr('class', 'area')
      .attr('d', area2)
  }
}

</script>

<style>

.nomogramDev path.line {
  stroke: steelblue;
  stroke-width: 2;
  fill: none;
}

.nomogramDev .area {
  fill: lightsteelblue;
  fill-opacity: 0.3;
}

.nomogramDev path.dashline {
  stroke: steelblue;
  stroke-dasharray: 5, 5;
  stroke-width: 2;
  fill: none;
}

.nomogramDev .axis path,
.nomogramDev .axis line {
  fill: none;
  stroke: grey;
  stroke-width: 1;
  shape-rendering: crispEdges;
}

/*
#qmax {
  position: relative;
}

#qmax::after {
  content: "";
  background: url("../assets/SirokyAvgSrc.png");
  opacity: 0.1;
  top: -65px;
  left: -904px;
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: -1;
  width:1904px;
}

#avg {
  position: relative;
}

#avg::after {
  content: "";
  background: url("../assets/SirokyAvgSrc.png");
  opacity: 0.1;
  top: -65px;
  left: -79px;
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: -1;
  width:1904px;
}
*/

</style>



// WEBPACK FOOTER //
// src/components/NomogramDev.vue